import {
  APP_ENVS,
  currentAppEnvironment,
} from '@savgroup-front-common/constants';

const LOGTO_ENABLED_HOSTNAMES = [
  'dev-app.revers.io',
  'dev2-app.revers.io',
  'demo-app.revers.io',
  'demo-control.revers.io',
  'demo2-app.revers.io',
  'app2.revers.io',
  'app.revers.io',
  'app.dev.revers.io',
  'app.demo.revers.io',

  'marwen-localhost.revers.io',

  'dev-app-carrefour.revers.io',
  'demo-app-carrefour.revers.io',
  'app-carrefour.revers.io',

  'demo-app-auchan.revers.io',
  'app-auchan.revers.io',

  'app-cooperative-u.revers.io',
  'demo-app-cooperative-u.revers.io',

  'demo-app-maisonsdumonde.revers.io',
  'app-maisonsdumonde.revers.io',

  'dev-field-service-app.revers.io',
  'demo-field-service-app.revers.io',
  'field-service.revers-app.io',
  'demo-app-cultura.revers.io',

  'dev-tools.revers.io',
];

const CONTROL_MAIN_PORT = '3002';
const DEFAULT_WORKTREE_PORTS = '3050,3051';

const getControlLocalPorts = (): string[] => [
  CONTROL_MAIN_PORT,
  ...String(import.meta.env.VITE_WORKTREE_PORTS || DEFAULT_WORKTREE_PORTS)
    .split(',')
    .map((port) => port.trim())
    .filter(Boolean),
];

export function isLogtoEnabled(): boolean {
  const isCurrentHostnameIsLogtoEnabled = LOGTO_ENABLED_HOSTNAMES.includes(
    typeof window !== 'undefined' ? window.location.hostname : '',
  );

  if (isCurrentHostnameIsLogtoEnabled) {
    return true;
  }

  const isBackOfficeFrontPreview =
    window?.location?.hostname.includes('.preview-front.dev-app.revers.io') ||
    window?.location?.hostname.includes('.preview.dev-app.revers.io');
  const isFieldServiceFrontPreview =
    window?.location?.hostname.includes(
      '.preview-front.dev-field-service-app.revers.io',
    ) ||
    window?.location?.hostname.includes(
      '.preview.dev-field-service-app.revers.io',
    );

  if (isBackOfficeFrontPreview || isFieldServiceFrontPreview) {
    return true;
  }

  if (window?.location?.hostname === 'localhost') {
    const isSelfcare = window.location.port === '3000';
    const isBackOffice = getControlLocalPorts().includes(window.location.port);
    const isFieldServiceApp = window.location.port === '3005';
    const isTools = window.location.port === '4006';

    if (import.meta.env.VITE_BASE_URL) {
      return !isSelfcare;
    }

    return isBackOffice || isFieldServiceApp || isTools;
  }

  if (currentAppEnvironment === APP_ENVS.PROD) {
    return false;
  }

  return false;
}
